import { render, staticRenderFns } from "./PendingPackages.vue?vue&type=template&id=40ed3f5e&scoped=true"
import script from "./PendingPackages.vue?vue&type=script&lang=js"
export * from "./PendingPackages.vue?vue&type=script&lang=js"
import style0 from "./PendingPackages.vue?vue&type=style&index=0&id=40ed3f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed3f5e",
  null
  
)

export default component.exports